<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-servizi.png"
      background-color="bg-black-light"
    >
      <template slot="title">
        Una risposta completa per proporre la tua casa nel modo migliore
      </template>
    </VisualHero>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 md:pt-20">
      <div class="container">
        <div class="mb-24 lg:mb-0">
          <h2 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            I servizi per te.
          </h2>
          <p class="mb-4">
            UniCredit RE Services offre a chi vuole vendere la propria casa o
            comprarne una nuova la competenza necessaria per trovare le
            soluzioni più adatte per soddisfare le tue esigenze. Con UniCredit
            RE Services al tuo fianco puoi contare su un
            <strong>partner affidabile e di valore</strong>, che ti accompagna,
            passo dopo passo, in uno dei momenti fondamentali della tua vita.
          </p>
          <p class="mb-4">
            Puoi inoltre contare su un
            <strong>modello di servizio specializzato</strong>
            basato su quattro valori fondamentali quali sicurezza, trasparenza,
            facilità e professionalità, garantita anche da una rete di
            consulenti immobiliari adeguatamente selezionati.
          </p>
        </div>
        <div class="mt-28 mb-20">
          <div class="hidden md:block">
            <h2
              class="hidden lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20 text-center"
            >
              9 motivi per vendere e comprare con UniCredit RE Services
            </h2>
            <div class="grid grid-cols-3 gap-16">
              <div
                v-for="(item, index) in itemsService"
                :key="index"
                class="bg-white-dark p-12"
              >
                <h3 class="text-2xl mb-10">
                  {{ index + 1 }}. {{ item.title }}
                </h3>
                <p v-dompurify-html="item.description"></p>
                <UcrsAnchor
                  v-if="item.link"
                  :label="item.link.text"
                  :to="item.link.href"
                  target="_blank"
                  class="mt-6"
                />
              </div>
            </div>
          </div>
          <Accordion
            class="block md:hidden border-b-0"
            heading=" 9 motivi per vendere e comprare con UniCredit RE Services"
            content-class="max-h-[2200px]"
          >
            <div class="grid grid-cols-1 gap-8">
              <div
                v-for="(item, index) in itemsService"
                :key="index"
                class="bg-white-dark p-12"
              >
                <h3 class="text-2xl mb-10">
                  {{ index + 1 }}. {{ item.title }}
                </h3>
                <p v-dompurify-html="item.description"></p>
                <UcrsAnchor
                  v-if="item.link"
                  :label="item.link.text"
                  :to="item.link.href"
                  target="_blank"
                  class="mt-6"
                />
              </div>
            </div>
          </Accordion>
          <!-- <BrochureAnchor class="mt-12" /> -->
        </div>
        <div class="block md:hidden mb-20">
          <StripBanner
            :link="
              $store.state.auth.loggedIn
                ? '/vendo'
                : '/area-riservata/registrati'
            "
            :btn-text="
              $store.state.auth.loggedIn ? 'Scopri di più' : 'Registrati subito'
            "
            root-class="-mx-6 md:mx-0 mt-10 mb-12"
          >
            <p v-if="$store.state.auth.loggedIn">
              Vuoi vendere casa? Gratis per te l'Attestato di Prestazione
              Energetica (APE).
            </p>
            <p v-else>
              Stai cercando casa e devi anche vendere?
              <br aria-hidden="true" />Registrati all'area riservata, scopri i
              nuovi servizi dedicati.
            </p>
          </StripBanner>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import Accordion from '~/components/Accordion.vue'
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
// // import BrochureAnchor from '~/components/BrochureAnchor.vue'
import StripBanner from '~/components/StripBanner.vue'
import UcrsAnchor from '~/components/UcrsAnchor.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    Accordion,
    BreadcrumbsWithShareAccordion,
    // BrochureAnchor,
    StripBanner,
    UcrsAnchor,
    VisualHero,
  },
  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: '9 motivi per vendere e comprare con UniCredit RE Services',
          description:
            'Una risposta completa per proporre la tua casa nel modo migliore. Scopri i 9 motivi per vendere e comprare con UniCredit RE Services.',
        }
      })
    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Servizi per te',
        },
      ],
      itemsService: [
        {
          title: 'Modello di servizio',
          description:
            'Un unico modello di servizio per tutto il territorio nazionale: vendere casa in Sicilia da Milano? con UniCredit RE Services puoi',
        },
        {
          title: 'Virtual Tour',
          description:
            'Il Virtual Tour è il nuovo servizio innovativo di UniCredit RE Services che ti permette di visitare tutti gli spazi della tua prossima casa stando a casa! Cerca le foto con il logo 360° e goditi un’esperienza di navigazione unica',
        },
        {
          title: 'Visibilità',
          description:
            'a: cartelli, materiale promozionale b: sito www.unicreditres.it e i principali portali immobiliari. c: stampa di settore',
        },
        {
          title: 'Valutazione commerciale',
          description:
            'La valutazione commerciale secondo i parametri della zona e del mercato immobiliare',
        },
        {
          title: 'Consulenza',
          description:
            'Fornire il supporto in ogni momento del processo fino alla stipula dell’atto notarile',
        },
        {
          title: 'Garanzie',
          description:
            'Garantire, per tutta la durata dell’incarico, la copertura assicurativa della responsabilità civile verso i propri Clienti per i rischi professionali',
        },
        {
          title: 'Servizi e documenti per la casa',
          description: 'Per gestire la compravendita',
          link: {
            text: 'scopri di piu',
            href: '/servizi-documenti-casa',
          },
        },
        {
          title: 'Servizio Prestige',
          description:
            'Un sistema di comunicazione di alta qualità progettato per la valorizzazione e la promozione degli immobili, dedicato ai proprietari di abitazioni di pregio',
        },
        {
          title: 'APP Plus',
          description:
            'Una soluzione innovativa, semplice e veloce che ti permetterà di affidarci il mandato a vendere in pochi clic, grazie ad una app affidabile e sicura.',
          link: { text: 'scopri di piu', href: '/scopri-app-plus' },
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
